module.exports = __webpack_public_path__ + "static/img/Logo@2x.3c3f328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImages/Logo@2x.png
// module id = 5Krc
// module chunks = 20